import { render } from "./AccessibilityStatement.vue?vue&type=template&id=a5d3dcec"
import script from "./AccessibilityStatement.vue?vue&type=script&setup=true&lang=js"
export * from "./AccessibilityStatement.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Support/AccessibilityStatement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a5d3dcec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a5d3dcec', __exports__)) {
    api.reload('a5d3dcec', __exports__)
  }
  
  module.hot.accept("./AccessibilityStatement.vue?vue&type=template&id=a5d3dcec", () => {
    api.rerender('a5d3dcec', render)
  })

}


export default __exports__